import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import tourData from '@app/assets/api-dummy-data.json';
import { TourGuideService } from '@app/services/tour-guide.service';
import { Messages } from '@app/src/util/messages';

@Component({
  selector: 'app-table-normal',
  templateUrl: './table-normal.component.html',
  styleUrls: ['./table-normal.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class TableNormalComponent {

  /****************** Variable declaration ******************/
  getNoData = Messages.no_data; //for getting no data available message

  /****************** Input and Output decorators ******************/
  @Input() dataSource: any;
  @Input() columnHeaders: any;
  @Input() columnsToDisplay: any;
  @Output() checkboxChange = new EventEmitter<{index: number, checked: boolean, data: any}>();

  /**
   * Constructor
   * @param cf 
   * @param TourguideService 
   */
  constructor(public cf: CommonFunctionalitiesService,
    public TourguideService: TourGuideService) {
  }

  /** ngOnInit */
  ngOnInit() {
    if (this.TourguideService.isStartTour) {
      this.dataSource = tourData.workflows.wfRun.quaitygates;
      return;
    }
  }

  /**
   * Handle checkbox change events
   */
  onCheckboxChange(index: number, checked: boolean, rowData: any) {
    this.checkboxChange.emit({index, checked, data: rowData});
  }
}
